import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import BackgroundMusic from "@/components/site/BackgroundMusic";

export default function SiteLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const scrollToHash = () => {
      const id = location.hash ? location.hash.slice(1) : null;
      if (!id) {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
        return;
      }
      const el = document.getElementById(id);
      if (el) {
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else el.scrollIntoView({ behavior: "smooth" });
      }
    };
    if (window.__lenis) window.__lenis.resize();
    // Small delay to allow content to mount
    const t = setTimeout(scrollToHash, 150);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);

  return (
    <div className="bg-[#050505]">
      <Nav />
      <Outlet />
      <Footer onEnroll={() => navigate("/enroll")} />
      <BackgroundMusic />
    </div>
  );
}
